import { render, staticRenderFns } from "./index.vue?vue&type=template&id=cdff01ea&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdff01ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2023/thShop/thShopAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cdff01ea')) {
      api.createRecord('cdff01ea', component.options)
    } else {
      api.reload('cdff01ea', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=cdff01ea&scoped=true&", function () {
      api.rerender('cdff01ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/member/memberMake/index.vue"
export default component.exports